import { useNavigation } from "@react-navigation/native";
import {
  useThemeProvider,
  Text,
  Button,
} from "@towersystems/roam-common-native";
import { View } from "react-native";

export interface ProductNotFoundProps {}

export function ProductNotFound(props: ProductNotFoundProps) {
  const { goBack } = useNavigation<any>();
  const { colors } = useThemeProvider();

  return (
    <View
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flex: 1,
      }}
    >
      <Text variant="heading2" color="subdued">
        Product not found
      </Text>
      <Button
        fullWidth
        style={{
          display: "flex",
        }}
        color={colors.textOnPrimary}
        backgroundColor={colors.primary}
        label="Continue"
        onPress={goBack}
      />
    </View>
  );
}
